import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { TransferListPage } from "@/screens/Inventory/subfeatures/Transfers/components"
import { transferSearchSchema } from "@/screens/Inventory/subfeatures/Transfers/schemas"

export const Route = createFileRoute("/app/inventory/_layout/transfers")({
  validateSearch: zodValidator(transferSearchSchema),
  component: () => <TransferListPage />,
})
